import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import axiosInstance from '../../services/axiosInstance';
import { authAPI, adminAPI } from '../../services/api';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
} from 'chart.js';
import { Line, Doughnut, Bar } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement
);





const AdminDashboard = () => {
  
  const navigate = useNavigate();
  const navigateToUserpage =  ()=>{
      navigate('/admin/users/true');
  }

  // State for popups
  const [nurseTrainee,setNurseTrainee] =  useState({trainedCount:0,inTrainingCount:0})
  const [showDoctorModal, setShowDoctorModal] = useState(false);
  const [showNurseModal, setShowNurseModal] = useState(false);
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [formData, setFormData] = useState({
    name:'',
    email: '',
    password: '',
    confirmPassword: '',
    role: 'nurse',
    timezone: 'Australia/Sydney',
    descriptions: [],
    qualifications: '',
    dateOfBirth:"2000-02-30"
  });


  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Dashboard stats state
  const [dashboardStats, setDashboardStats] = useState({
    totalPatients: 0,
    sessionsToday: 0,
    activeSubscriptions: 0,
    monthlyRevenue: 0
  });
  const [statsLoading, setStatsLoading] = useState(true);
  const [statsError, setStatsError] = useState(null);

  // Recent sessions state
  const [recentSessions, setRecentSessions] = useState([]);
  const [sessionsLoading, setSessionsLoading] = useState(true);
  const [sessionsError, setSessionsError] = useState(null);

  // Recent payments state
  const [recentPayments, setRecentPayments] = useState([]);
  const [paymentsLoading, setPaymentsLoading] = useState(true);
  const [paymentsError, setPaymentsError] = useState(null);

  // Weekly sessions state
  const [weeklySessions, setWeeklySessions] = useState([]);
  const [weeklyLoading, setWeeklyLoading] = useState(true);
  const [weeklyError, setWeeklyError] = useState(null);

  // Performance overview state
  const [performanceData, setPerformanceData] = useState({
    liveSessions: 0,
    queue: 0,
    completed: 0,
    revenue: 0,
    dailyTarget: 0,
    patientSatisfaction: 0
  });
  const [performanceLoading, setPerformanceLoading] = useState(true);
  const [performanceError, setPerformanceError] = useState(null);

  // Main Chart data
  const chartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    datasets: [
      {
        label: 'Patient Registrations',
        data: [2000, 2200, 2500, 2300, 2800, 3100, 3400, 3600, 3800],
        borderColor: '#3b82f6',
        backgroundColor: 'rgba(59, 130, 246, 0.1)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#3b82f6',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
      },
      {
        label: 'Therapy Sessions',
        data: [1800, 1900, 2100, 2000, 2300, 2500, 2700, 2900, 3000],
        borderColor: '#10b981',
        backgroundColor: 'rgba(16, 185, 129, 0.1)',
        fill: false,
        tension: 0.4,
        pointBackgroundColor: '#10b981',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
      },
      {
        label: 'Monthly Revenue ($)',
        data: [1600, 1700, 1900, 1800, 2100, 2300, 2500, 2700, 2800],
        borderColor: '#f59e0b',
        backgroundColor: 'rgba(245, 158, 11, 0.1)',
        fill: false,
        tension: 0.4,
        pointBackgroundColor: '#f59e0b',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
      },
    ],
  };

  // Weekly Performance Chart (Right Side)
  const weeklyData = {
    labels: weeklySessions.map(session => session.day),
    datasets: [
      {
        label: 'Nurse Sessions',
        data: weeklySessions.map(session => session.count),
        borderColor: '#8b5cf6',
        backgroundColor: 'rgba(139, 92, 246, 0.1)',
        fill: true,
        tension: 0.4,
        pointBackgroundColor: '#8b5cf6',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 4,
      },
    ],
  };

  useEffect(() => {
  const fetchNurseTrainingInfo = async () => {
      try {
        const res = await axiosInstance.get(`/admin/nurse-training-info`);
        const {trainedCount,inTrainingCount} = res.data
        setNurseTrainee({trainedCount,inTrainingCount});
      } catch (error) {
        console.error("Error fetching course:", error);
      }
    };
    fetchNurseTrainingInfo();
  }, []);

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // We'll use custom legend
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: '#e5e7eb',
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: true,
        intersect: false,
        mode: 'index',
      },
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(241, 245, 249, 0.7)',
          drawBorder: false,
        },
        ticks: {
          color: '#64748b',
          font: {
            size: 11,
            weight: 500,
          },
        },
      },
      y: {
        grid: {
          color: 'rgba(241, 245, 249, 0.7)',
          drawBorder: false,
        },
        ticks: {
          color: '#64748b',
          font: {
            size: 11,
            weight: 500,
          },
          callback: function(value) {
            return value >= 1000 ? (value / 1000) + 'K' : value;
          },
        },
        beginAtZero: true,
      },
    },
    interaction: {
      intersect: false,
      mode: 'index',
    },
    elements: {
      point: {
        hoverRadius: 8,
      },
    },
  };

  // Weekly chart options (smaller)
  const weeklyOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        cornerRadius: 6,
        callbacks: {
          title: function(tooltipItems) {
            return tooltipItems[0].raw > 1 
              ? `${tooltipItems[0].raw} Sessions` 
              : `${tooltipItems[0].raw} Session`;
          },
          label: function(context) {
            return `${context.dataset.label} on ${weeklySessions[context.dataIndex].date}`;
          }
        }
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#64748b',
          font: {
            size: 10,
          },
        },
      },
      y: {
        grid: {
          color: 'rgba(241, 245, 249, 0.5)',
          drawBorder: false,
        },
        ticks: {
          color: '#64748b',
          font: {
            size: 10,
          },
          maxTicksLimit: 5,
          stepSize: 1,
          callback: function(value) {
            return Number.isInteger(value) ? value : '';
          }
        },
        beginAtZero: true,
      },
    },
  };

  // Performance Bar Chart Options
  const performanceOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        cornerRadius: 6,
        callbacks: {
          label: function(context) {
            const label = context.dataset.label || '';
            const value = context.parsed.y;
            if (context.dataIndex === 3) { // Satisfaction
              return `${label}: ${value}%`;
            }
            return `${label}: ${value}`;
          }
        }
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: '#64748b',
          font: {
            size: 10,
          },
        },
      },
      y: {
        grid: {
          color: 'rgba(241, 245, 249, 0.5)',
          drawBorder: false,
        },
        ticks: {
          color: '#64748b',
          font: {
            size: 10,
          },
          maxTicksLimit: 5,
        },
        beginAtZero: true,
      },
    },
  };

  // Handle form input changes
const handleInputChange = (e) => {
  const { name, value } = e.target;

  if (name.startsWith("description_")) {
    // extract index number from description_0, description_1, ...
    const index = parseInt(name.split("_")[1], 10);
    const updatedDescriptions = [...formData.descriptions];
    updatedDescriptions[index] = value;

    setFormData({
      ...formData,
      descriptions: updatedDescriptions,
    });
  } else {
    // for normal fields
    setFormData({
      ...formData,
      [name]: value,
    });
  }
};


  // Handle form submission
  const handleSubmit = async (e, role) => {
    e.preventDefault();
    
    // Validation
    if (formData.password !== formData.confirmPassword) {
      setMessage('Passwords do not match!');
      return;
    }

    if (formData.password.length < 6) {
      setMessage('Password must be at least 6 characters long!');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      await authAPI.register(formData);
      
      setMessage(`${role === 'psychiatrist' ? 'Doctor' : 'Nurse'} added successfully!`);
      
      // Reset form
      setFormData({
        name:'',
        email: '',
        password: '',
        confirmPassword: '',
        role: 'nurse',
        timezone: 'Australia/Sydney',
        descriptions: [],
        qualifications: '',
        dateOfBirth:"2000-02-30"
      });

      // Close modal after 2 seconds
      setTimeout(() => {
        setShowDoctorModal(false);
        setShowNurseModal(false);
        setMessage('');
      }, 2000);

    } catch (error) {
      setMessage(error.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Fetch dashboard stats
  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        console.log('🔄 Starting to fetch dashboard stats...');
        setStatsLoading(true);
        setStatsError(null);
        
        const response = await adminAPI.getDashboardStats();
        console.log('✅ Dashboard stats response:', response);
        
        if (response) {
          setDashboardStats({
            totalPatients: response.totalPatients || 0,
            sessionsToday: response.sessionsToday || 0,
            activeSubscriptions: response.activeSubscriptions || 0,
            monthlyRevenue: response.monthlyRevenue || 0
          });
          console.log('✅ Dashboard stats updated:', {
            totalPatients: response.totalPatients || 0,
            sessionsToday: response.sessionsToday || 0,
            activeSubscriptions: response.activeSubscriptions || 0,
            monthlyRevenue: response.monthlyRevenue || 0
          });
        } else {
          throw new Error('Invalid response from API');
        }
      } catch (err) {
        console.error('❌ Error fetching dashboard stats:', err);
        setStatsError(err.message);
        
        // Keep default values on error
        setDashboardStats({
          totalPatients: 0,
          sessionsToday: 0,
          activeSubscriptions: 0,
          monthlyRevenue: 0
        });
      } finally {
        setStatsLoading(false);
        console.log('✅ Dashboard stats loading completed');
      }
    };

    fetchDashboardStats();
  }, []);

  // Fetch recent sessions
  useEffect(() => {
    const fetchRecentSessions = async () => {
      try {
        console.log('🔄 Starting to fetch recent sessions...');
        setSessionsLoading(true);
        setSessionsError(null);
        
        const response = await adminAPI.getRecentSessions();
        console.log('✅ Recent sessions response:', response);
        
        // Handle different response structures
        let sessions = [];
        if (response && response.recentSessions) {
          // If response has a recentSessions property (your API structure)
          sessions = response.recentSessions;
        } else if (response && response.sessions) {
          // If response has a sessions property
          sessions = response.sessions;
        } else if (response && Array.isArray(response)) {
          // If response is directly an array
          sessions = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          // If response has a data property that's an array
          sessions = response.data;
        } else if (response && response.data && response.data.sessions) {
          // If response has data.sessions
          sessions = response.data.sessions;
        } else {
          console.warn('⚠️ Unexpected response structure:', response);
          sessions = [];
        }
        
        setRecentSessions(sessions);
        console.log('✅ Recent sessions updated:', sessions);
      } catch (err) {
        console.error('❌ Error fetching recent sessions:', err);
        setSessionsError(err.message);
        setRecentSessions([]);
      } finally {
        setSessionsLoading(false);
        console.log('✅ Recent sessions loading completed');
      }
    };

    fetchRecentSessions();
  }, []);

  // Fetch recent payments
  useEffect(() => {
    const fetchRecentPayments = async () => {
      try {
        console.log('🔄 Starting to fetch recent payments...');
        setPaymentsLoading(true);
        setPaymentsError(null);
        
        const response = await adminAPI.getRecentPayments();
        console.log('✅ Recent payments response:', response);
        
        // Handle different response structures
        let payments = [];
        if (response && response.recentPayments) {
          // If response has a recentPayments property (your API structure)
          payments = response.recentPayments;
        } else if (response && response.payments) {
          // If response has a payments property
          payments = response.payments;
        } else if (response && Array.isArray(response)) {
          // If response is directly an array
          payments = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          // If response has a data property that's an array
          payments = response.data;
        } else if (response && response.data && response.data.payments) {
          // If response has data.payments
          payments = response.data.payments;
        } else {
          console.warn('⚠️ Unexpected response structure:', response);
          payments = [];
        }
        
        setRecentPayments(payments);
        console.log('✅ Recent payments updated:', payments);
      } catch (err) {
        console.error('❌ Error fetching recent payments:', err);
        setPaymentsError(err.message);
        setRecentPayments([]);
      } finally {
        setPaymentsLoading(false);
        console.log('✅ Recent payments loading completed');
      }
    };

    fetchRecentPayments();
  }, []);

  // Fetch weekly sessions
  useEffect(() => {
    const fetchWeeklySessions = async () => {
      try {
        console.log('🔄 Starting to fetch weekly sessions...');
        setWeeklyLoading(true);
        setWeeklyError(null);        
        const response = await adminAPI.getWeeklySessions();
        console.log('✅ Weekly sessions response:', response);
        
        // Handle different response structures
        let sessions = [];
        if (response && response.weeklySessions) {
          // If response has a weeklySessions property
          sessions = response.weeklySessions;
        } else if (response && response.sessions) {
          // If response has a sessions property
          sessions = response.sessions;
        } else if (response && Array.isArray(response)) {
          // If response is directly an array
          sessions = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          // If response has a data property that's an array
          sessions = response.data;
        } else if (response && response.data && response.data.weeklySessions) {
          // If response has data.weeklySessions
          sessions = response.data.weeklySessions;
        } else {
          console.warn('⚠️ Unexpected response structure:', response);
          sessions = [];
        }
        
        setWeeklySessions(sessions);
        console.log('✅ Weekly sessions updated:', sessions);
      } catch (err) {
        console.error('❌ Error fetching weekly sessions:', err);
        setWeeklyError(err.message);
        setWeeklySessions([]);
      } finally {
        setWeeklyLoading(false);
        console.log('✅ Weekly sessions loading completed');
      }
    };

    fetchWeeklySessions();
  }, []);

  // Fetch performance overview
  useEffect(() => {
    const fetchPerformanceOverview = async () => {
      try {
        console.log('🔄 Starting to fetch performance overview...');
        setPerformanceLoading(true);
        setPerformanceError(null);
        
        const response = await adminAPI.getPerformanceOverview();
        console.log('✅ Performance overview response:', response);
        
        // Handle different response structures
        let data = {};
        if (response && response.performanceOverview) {
          // If response has a performanceOverview property
          data = response.performanceOverview;
        } else if (response && response.data) {
          // If response has a data property
          data = response.data;
        } else if (response && typeof response === 'object') {
          // If response is directly an object
          data = response;
        } else {
          console.warn('⚠️ Unexpected response structure:', response);
          data = {};
        }
        
        setPerformanceData({
          liveSessions: data.liveSessions || data.live_sessions || 0,
          queue: data.queue || 0,
          completed: data.completed || 0,
          revenue: data.revenue || 0,
          dailyTarget: data.dailyTarget || data.daily_target || 0,
          patientSatisfaction: data.patientSatisfaction || data.patient_satisfaction || 0
        });
        console.log('✅ Performance overview updated:', data);
      } catch (err) {
        console.error('❌ Error fetching performance overview:', err);
        setPerformanceError(err.message);
        setPerformanceData({
          liveSessions: 0,
          queue: 0,
          completed: 0,
          revenue: 0,
          dailyTarget: 0,
          patientSatisfaction: 0
        });
      } finally {
        setPerformanceLoading(false);
        console.log('✅ Performance overview loading completed');
      }
    };

    fetchPerformanceOverview();
  }, []);

  // Helper functions for session data
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'completed':
        return 'green';
      case 'in progress':
      case 'active':
        return 'blue';
      case 'scheduled':
      case 'pending':
        return 'yellow';
      case 'cancelled':
      case 'failed':
        return 'red';
      default:
        return 'gray';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    });
  };

  const getProfileImageUrl = (profileImage) => {
    console.log('getProfileImageUrl called with:', profileImage);
    
    if (!profileImage || profileImage === 'null') {
      return 'https://cdn-icons-png.flaticon.com/512/149/149071.png';
    }

    if (profileImage.startsWith('http')) {
      return profileImage;
    }

    const baseUrl = process.env.REACT_APP_BASE_URL || 'https://backend.adhdrapidcare.com';
    
    // Remove any duplicate slashes and handle paths correctly
    const cleanPath = profileImage.startsWith('/') ? profileImage.substring(1) : profileImage;
    return `${baseUrl}/${cleanPath}`;
  };

  // Helper functions for payment data
  const getPaymentStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'paid':
      case 'completed':
      case 'success':
        return 'green';
      case 'pending':
      case 'processing':
        return 'yellow';
      case 'failed':
      case 'cancelled':
      case 'declined':
        return 'red';
      default:
        return 'gray';
    }
  };

  const formatCurrency = (amount) => {
    if (!amount) return '$0';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(numAmount);
  };

  return (
    <>
      <div className={`${showDoctorModal || showNurseModal ? 'filter blur-sm' : ''} transition-all duration-300`}>
        {/* Dashboard Content */}
            {/* Page Title */}
            <div className="mb-6 md:mb-8">
              <h1 className="text-xl md:text-2xl font-semibold text-gray-800">Admin Dashboard</h1>
              <p className="text-gray-600 mt-2">Welcome back! Here's an overview of your ADHD care platform.</p>
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 md:gap-8 mb-6 md:mb-8">
              {/* Left Side - Cards */}
              <div className="space-y-6">
                {/* Stats Cards - Responsive */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    {
                      iconBg: "bg-green-100",
                      iconColor: "text-green-600",
                      cardBg: "bg-green-50",
                      iconPath:
                        "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
                      value: statsLoading ? "..." : dashboardStats.totalPatients.toString(),
                      label: "Total Patients",
                    },
                    {
                      iconBg: "bg-blue-100",
                      iconColor: "text-blue-600",
                      cardBg: "bg-blue-50",
                      iconPath:
                        "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z",
                      value: statsLoading ? "..." : dashboardStats.sessionsToday.toString(),
                      label: "Sessions Today",
                    },
                    {
                      iconBg: "bg-purple-100",
                      iconColor: "text-purple-600",
                      cardBg: "bg-purple-50",
                      iconPath:
                        "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
                      value: statsLoading ? "..." : dashboardStats.activeSubscriptions.toString(),
                      label: "Active Subscriptions",
                    },
                    {
                      iconBg: "bg-yellow-100",
                      iconColor: "text-yellow-600",
                      cardBg: "bg-yellow-50",
                      iconPath:
                        "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z",
                      value: statsLoading ? "..." : `$${(dashboardStats.monthlyRevenue)}`,
                      label: "Monthly Revenue",
                    },
                  ].map((item, index) => (
                    <div key={index} className={`rounded-2xl p-4 shadow-md border border-gray-200 ${item.cardBg}`}>
                      <div className="flex items-center justify-between">
                        <div>
                          <div className={`w-6 h-6 ${item.iconBg} rounded-lg flex items-center justify-center mb-2`}>
                            <svg className={`w-4 h-4 ${item.iconColor}`} fill="currentColor" viewBox="0 0 24 24">
                              <path d={item.iconPath} />
                            </svg>
                          </div>
                          <p className="text-xl font-bold text-gray-900">
                            {statsLoading ? (
                              <div className="h-6 bg-gray-200 rounded animate-pulse w-16"></div>
                            ) : (
                              item.value
                            )}
                          </p>
                          <p className="text-sm text-gray-500 mt-0.5">
                            {item.label}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

              
              </div>

              {/* Right Side - Charts */}
              <div className="space-y-6">
              

                {/* Weekly Sessions Chart */}
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-lg font-semibold text-gray-900">Weekly Sessions</h3>
                    <span className="text-sm text-purple-600 font-medium">This Week</span>
                  </div>
                  <div className="h-40">
                    {weeklyLoading ? (
                      // Card content loader
                      <div className="h-full flex flex-col justify-center space-y-3">
                        {/* Chart area skeleton */}
                        <div className="flex-1 bg-gray-100 rounded-lg p-4">
                          <div className="h-full flex items-end justify-between space-x-2">
                            {Array.from({ length: 7 }).map((_, idx) => (
                              <div key={idx} className="flex-1 flex flex-col items-center space-y-2">
                                {/* Bar skeleton */}
                                <div 
                                  className="w-full bg-gray-200 rounded-t animate-pulse"
                                  style={{ 
                                    height: `${Math.random() * 60 + 20}%`,
                                    minHeight: '20px'
                                  }}
                                ></div>
                                {/* Day label skeleton */}
                                <div className="h-3 bg-gray-200 rounded w-6 animate-pulse"></div>
                              </div>
                            ))}
                          </div>
                        </div>
                        
                        {/* Legend skeleton */}
                        <div className="flex items-center justify-center space-x-4">
                          <div className="flex items-center space-x-2">
                            <div className="w-3 h-3 bg-gray-200 rounded animate-pulse"></div>
                            <div className="h-3 bg-gray-200 rounded w-16 animate-pulse"></div>
                          </div>
                        </div>
                      </div>
                    ) : weeklyError ? (
                      // Error state
                      <div className="flex items-center justify-center h-full">
                        <div className="text-center">
                          <div className="text-red-500 mb-2">
                            <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                          </div>
                          <p className="text-sm text-gray-600">Failed to load weekly data</p>
                          <p className="text-xs text-gray-400 mt-1">{weeklyError}</p>
                        </div>
                      </div>
                    ) : weeklySessions.length === 0 ? (
                      // Empty state
                      <div className="flex items-center justify-center h-full">
                        <div className="text-center">
                          <div className="text-gray-400 mb-2">
                            <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                          </div>
                          <p className="text-sm text-gray-600">No weekly data available</p>
                        </div>
                      </div>
                    ) : (
                      // Chart with real data
                      <Line data={weeklyData} options={weeklyOptions} />
                    )}
                  </div>
                </div>

                
                
              </div>
            </div>

            {/* Performance Overview Dashboard - Responsive */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
              {/* Main Performance Card */}
              <div className="lg:col-span-2 bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <div className="flex items-center justify-between mb-6">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900">Performance Overview</h2>
                    <p className="text-gray-500 mt-1">Today's key metrics and insights</p>
                  </div>
                  <div className="bg-gray-100 rounded-xl p-3">
                    <svg className="w-8 h-8 text-gray-600" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                    </svg>
                  </div>
                </div>

                {performanceError ? (
                  // Error state
                  <div className="text-center py-8">
                    <div className="text-red-500 mb-4">
                      <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <p className="text-gray-600 mb-2">Failed to load performance data</p>
                    <p className="text-gray-400 text-sm">{performanceError}</p>
                  </div>
                ) : (
                  <>
                    {/* Live Stats Grid - Responsive */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                      <div className="bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center space-x-2 mb-2">
                          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                          <span className="text-sm text-gray-600">Live Sessions</span>
                        </div>
                        <p className="text-2xl font-bold text-gray-900">
                          {performanceLoading ? (
                            <div className="h-8 bg-gray-200 rounded animate-pulse w-12"></div>
                          ) : (
                            performanceData.liveSessions
                          )}
                        </p>
                        <p className="text-xs text-gray-500">+12% vs yesterday</p>
                      </div>
                      
                      <div className="bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center space-x-2 mb-2">
                          <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
                          <span className="text-sm text-gray-600">Queue</span>
                        </div>
                        <p className="text-2xl font-bold text-gray-900">
                          {performanceLoading ? (
                            <div className="h-8 bg-gray-200 rounded animate-pulse w-8"></div>
                          ) : (
                            performanceData.queue
                          )}
                        </p>
                        <p className="text-xs text-gray-500">Waiting patients</p>
                      </div>
                      
                      <div className="bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center space-x-2 mb-2">
                          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                          <span className="text-sm text-gray-600">Completed</span>
                        </div>
                        <p className="text-2xl font-bold text-gray-900">
                          {performanceLoading ? (
                            <div className="h-8 bg-gray-200 rounded animate-pulse w-16"></div>
                          ) : (
                            performanceData.completed
                          )}
                        </p>
                        <p className="text-xs text-gray-500">Today</p>
                      </div>
                      
                      <div className="bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center space-x-2 mb-2">
                          <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                          <span className="text-sm text-gray-600">Revenue</span>
                        </div>
                        <p className="text-2xl font-bold text-gray-900">
                          {performanceLoading ? (
                            <div className="h-8 bg-gray-200 rounded animate-pulse w-16"></div>
                          ) : (
                            formatCurrency(performanceData.revenue)
                          )}
                        </p>
                        <p className="text-xs text-gray-500">Today's total</p>
                      </div>
                    </div>

                    {/* Nurse Status Cards - Below the main stats */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                      <div className="bg-gradient-to-r from-emerald-50 to-emerald-100 rounded-xl p-4 border border-emerald-200">
                        <div className="flex items-center space-x-2 mb-2">
                          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                          <span className="text-sm text-gray-600">Certified Nurse</span>
                        </div>
                        <p className="text-xl font-bold text-emerald-900">
                          {performanceLoading ? (
                            <div className="h-6 bg-emerald-200 rounded animate-pulse w-12"></div>
                          ) : (
                            
                              nurseTrainee.trainedCount
                            
                          )}
                        </p>
                        {/* <p className="text-xs text-emerald-600">Fully qualified & active</p> */}
                      </div>
                      
                      <div className="bg-gradient-to-r from-amber-50 to-amber-100 rounded-xl p-4 border border-amber-200">

                        <div className="flex items-center space-x-2 mb-2">
                          <div className="w-2 h-2 bg-yellow-500 rounded-full"></div>
                          <span className="text-sm text-gray-600">In Trainee Nurse</span>
                        </div>
                        <p className="text-xl font-bold text-amber-900">
                          {performanceLoading ? (
                            <div className="h-6 bg-amber-200 rounded animate-pulse w-12"></div>
                          ) : (
                            
                              nurseTrainee.inTrainingCount
                            
                          )}
                        </p>
                        {/* <p className="text-xs text-amber-600">Under supervision</p> */}
                      </div>
                    </div> 
                  </>
                )}
              </div>

              {/* Side Widgets */}
              <div className="space-y-6">
                {/* Quick Actions */}
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
                  <div className="space-y-3">
                    <button 
                      onClick={() => setShowNurseModal(true)}
                    className="w-full bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white p-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-[1.02] flex items-center justify-center space-x-2 shadow-lg">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
                    </svg>
                      <span>Add Nurse</span>
                    </button>
                  </div>
                  <div className="space-y-3 mt-3">
                    <button 
                    onClick={() => navigateToUserpage()}
                    className="w-full bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white p-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-[1.02] flex items-center justify-center space-x-2 shadow-lg">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3" />
                    </svg>
                      <span>View Training Report</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Recent Activities - Responsive */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 py-4 md:py-6">
              {/* Recent Sessions */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                <div className="p-4 border-b border-gray-300 bg-gray-50">
                  <h3 className="text-lg font-semibold">Recent Sessions</h3>
                </div>
                <div className="divide-y divide-gray-100">
                  {sessionsLoading ? (
                    // Loading skeleton
                    Array.from({ length: 5 }).map((_, idx) => (
                      <div key={idx} className="flex items-center justify-between px-6 py-4">
                        <div className="flex items-center gap-4">
                          <div className="w-10 h-10 bg-gray-200 rounded-full animate-pulse"></div>
                          <div>
                            <div className="h-4 bg-gray-200 rounded w-24 animate-pulse mb-1"></div>
                            <div className="h-3 bg-gray-200 rounded w-16 animate-pulse"></div>
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="h-3 bg-gray-200 rounded w-20 animate-pulse mb-1"></div>
                          <div className="h-5 bg-gray-200 rounded w-16 animate-pulse"></div>
                        </div>
                      </div>
                    ))
                  ) : sessionsError ? (
                    // Error state
                    <div className="px-6 py-8 text-center">
                      <div className="text-red-500 mb-2">
                        <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <p className="text-gray-600 text-sm">Failed to load recent sessions</p>
                      <p className="text-gray-400 text-xs mt-1">{sessionsError}</p>
                    </div>
                  ) : recentSessions.length === 0 ? (
                    // Empty state
                    <div className="px-6 py-8 text-center">
                      <div className="text-gray-400 mb-2">
                        <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                      </div>
                      <p className="text-gray-600 text-sm">No recent sessions found</p>
                    </div>
                  ) : (
                    (() => { console.log('Rendering recentSessions:', recentSessions); return recentSessions; })().map((session, idx) => (
                      <div key={idx} className="flex items-center justify-between px-6 py-4 hover:bg-blue-50">
                        <div className="flex items-center gap-4">
                          <img src={getProfileImageUrl(session.profileImage || session.image)} alt={session.name} className="w-10 h-10 rounded-full object-cover" />
                          <div>
                            <p className="font-medium text-gray-800">{session.name}</p>
                            <p className="text-sm text-gray-500">{session.type}</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="text-sm text-gray-500 mb-1">{formatDate(session.date)}</p>
                          <span className={`text-xs px-2 py-1 rounded-full font-medium bg-${getStatusColor(session.status)}-100 text-${getStatusColor(session.status)}-700`}>
                            {session.status}
                          </span>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>

              {/* Recent Payments */}
              <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                <div className="p-4 border-b border-gray-300 bg-gray-50">
                  <h3 className="text-lg font-semibold">Recent Payments</h3>
                </div>
                <div className="overflow-x-auto">
                  {paymentsLoading ? (
                    // Loading skeleton
                    <div className="p-6">
                      {Array.from({ length: 5 }).map((_, idx) => (
                        <div key={idx} className="flex items-center justify-between py-3 border-b border-gray-100 last:border-b-0">
                          <div className="h-4 bg-gray-200 rounded w-24 animate-pulse"></div>
                          <div className="h-4 bg-gray-200 rounded w-20 animate-pulse"></div>
                          <div className="h-4 bg-gray-200 rounded w-16 animate-pulse"></div>
                          <div className="h-5 bg-gray-200 rounded w-12 animate-pulse"></div>
                        </div>
                      ))}
                    </div>
                  ) : paymentsError ? (
                    // Error state
                    <div className="px-6 py-8 text-center">
                      <div className="text-red-500 mb-2">
                        <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <p className="text-gray-600 text-sm">Failed to load recent payments</p>
                      <p className="text-gray-400 text-xs mt-1">{paymentsError}</p>
                    </div>
                  ) : recentPayments.length === 0 ? (
                    // Empty state
                    <div className="px-6 py-8 text-center">
                      <div className="text-gray-400 mb-2">
                        <svg className="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                        </svg>
                      </div>
                      <p className="text-gray-600 text-sm">No recent payments found</p>
                    </div>
                  ) : (
                    <table className="w-full text-sm text-left min-w-full">
                      <thead className="bg-gray-100 text-gray-600 text-xs uppercase">
                        <tr>
                          <th className="px-6 py-3">Date</th>
                          <th className="px-6 py-3">Patient</th>
                          <th className="px-6 py-3">Amount</th>
                          <th className="px-6 py-3">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentPayments.map((payment, idx) => (
                          <tr key={idx} className="border-b hover:bg-blue-50">
                            <td className="px-6 py-4 font-medium text-gray-900">
                              {formatDate(payment.date)}
                            </td>
                            <td className="px-6 py-4">
                              {payment.patient || payment.patientName || 'Unknown Patient'}
                            </td>
                            <td className="px-6 py-4">
                              {formatCurrency(payment.amount)}
                            </td>
                            <td className="px-6 py-4">
                              <span className={`bg-${getPaymentStatusColor(payment.status)}-100 text-${getPaymentStatusColor(payment.status)}-700 px-2 py-1 rounded-full text-xs`}>
                                {payment.status}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
      </div>

      {/* Add Nurse Modal */}
      {showNurseModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-3 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">Add New Nurse</h2>
              <button
                onClick={() => {
                  setShowNurseModal(false);
                  setMessage('');
                  setFormData({
                    email: '',
                    password: '',
                    confirmPassword: '',
                    role: '',
                    timezone: 'Australia/Sydney',
                    descriptions: [],
                    qualifications: '',
                    dateOfBirth:"2000-02-30"
                  });

                }}
                className="text-gray-400 hover:text-gray-600"
              >

                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Form */}
            <form onSubmit={(e) => handleSubmit(e, 'nurse')} className="py-4 space-y-2">
            <div className='mx-6'>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Enter Name <span className="text-red-500">*</span></label>
              <input
                type="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter name"
              />
            </div>
            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email Address <span className="text-red-500">*</span></label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter email address"
              />
            </div>

            {/* Password and Confirm Password */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Password <span className="text-red-500">*</span></label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter password"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password <span className="text-red-500">*</span></label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required
                  className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Confirm password"
                />
              </div>
            </div>

            {/* Role and Timezone in one row */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Role <span className="text-red-500">*</span></label>
                <input
                  type="text"
                  value="Nurse"
                  disabled
                  className="w-full px-3 py-1.5 border border-gray-300 bg-white rounded-md text-sm text-gray-500 cursor-not-allowed"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Timezone <span className="text-red-500">*</span></label>
                <select
                  name="timezone"
                  value={formData.timezone}
                  onChange={handleInputChange}
                  className="w-full px-3 py-1.5 border border-gray-300 bg-white rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="Australia/Sydney">New South Wales</option>
                  <option value="Australia/Darwin">Northern Territory</option>
                  <option value="Australia/Brisbane">Queensland</option>
                  <option value="Australia/Adelaide">South Australia</option>
                  <option value="Australia/Hobart">Tasmania</option>
                  <option value="Australia/Melbourne">Victoria</option>
                  <option value="Australia/Perth">Western Australia</option>
                </select>
              </div>
            </div>

            {/* Qualifications */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Qualifications <span className="text-red-500">*</span></label>
              <input
                type="text"
                name="qualifications"
                value={formData.qualifications}
                onChange={handleInputChange}
                required
                className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter qualifications (e.g., RN, BSN, MSN)"
              />
            </div>

            <div>
            <label className="block text-sm font-medium text-gray-700 mt-2 mb-1">Description (Optional)</label>
            <div className="space-y-1">
              <textarea
                name="description_0"
                value={formData.descriptions[0]}
                onChange={handleInputChange}
                rows="2"
                className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Line 1"
              />
              
              <textarea
                name="description_1"
                value={formData.descriptions[1]}
                onChange={handleInputChange}
                rows="2"
                className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Line 2"
              />
              
              <textarea
                name="description_2"
                value={formData.descriptions[2]}
                onChange={handleInputChange}
                rows="2"
                className="w-full px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Line 3"
              />
            </div>
            </div>



              {/* Alert */}
              {message && (
                <div className={`p-3 rounded-md text-sm ${message.includes('success') ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>
                  {message}
                </div>
              )}
            </div>

            
              {/* Actions */}
              <div className="flex justify-end gap-3 pt-3 px-6 border-t border-gray-200">
                <button
                  type="button"
                  onClick={() => {
                    setShowNurseModal(false);
                    setMessage('');
                    setFormData({
                      email: '',
                      password: '',
                      confirmPassword: '',
                      role: '',
                      timezone: 'Australia/Sydney',
                      descriptions: ['', '', ''],
                      qualifications: ''
                    });
                  }}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md disabled:opacity-50"
                >
                  {loading ? 'Adding Nurse...' : 'Add Nurse'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>  
  );
};

export default AdminDashboard;
